import { c as _c } from "react/compiler-runtime";
import { usePageView } from '@/analytics/pageTypes';
import { Layout } from '@/components/layout';
import IconGlobe from '@/assets/icons/heroIcons/GlobeAlt.svg';
import IconPackages from '@/assets/icons/heroIcons/Packages.svg';
import IconUserGroup from '@/assets/icons/heroIcons/User-group.svg';
import IconPuzzle from '@/assets/icons/heroIcons/Puzzle.svg';
import { getIntlProps, type IntlProps } from '@/utils/intl';
import type { GetStaticProps } from 'next';
import { Trans, useTranslation } from 'react-i18next';
import React from 'react';
import HeroSimple from '@/sections/HeroSimple';
import { SettingBox } from '@/sections/privacySettings/SettingBox';
import { getAllCookies, Cookie } from '@/api/sanity/cookies';
import { Field, Form as FinalForm } from 'react-final-form';
import { addPrefixToDataParams } from '@/utils/string';
import { Button } from '@/components/buttons';
import { SwitchInput } from '@/components/inputs';
import { toast } from 'react-toastify';
import { useCookiesConsent } from '@/sections/privacySettings/hooks/useCookiesConsent';
import { SeoHeader } from '@/components/SeoHeader';
import { sleep } from '@/utils/promise';
import { Link } from '@/components/links';
import { LINKS } from '@/constants/links';
import { getAllPageMenuPromoBanners, PageMenuPromoBanner } from '@/api/sanity/pageMenuPromoBanner';
const cookiesCategory = {
  essentials: 'essentials',
  personalization: 'personalization',
  remarketing: 'remarketing',
  analytics: 'analytics'
};
interface Props extends IntlProps {
  cookies: Cookie[] | null;
  menuPromoBanners?: PageMenuPromoBanner[];
}
export default function Page(t0) {
  const $ = _c(40);
  const {
    cookies,
    menuPromoBanners
  } = t0;
  usePageView("privacy-settings");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["privacySettings", "core"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  const {
    isPending,
    data
  } = useCookiesConsent();
  let t2;
  if ($[1] !== t) {
    t2 = t("seo.title");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("seo.description");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <SeoHeader title={t2} description={t3} />;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("banner.title");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Link to={LINKS().informationMemorandum} analyticsParam="privacySettingsInformationMemorandum" testId="privacySettingsInformationMemorandum" />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t) {
    t7 = <p className="mx-auto mt-6 max-w-192 text-center lg:text-xl"><Trans i18nKey="banner.text" t={t}>{t6}</Trans></p>;
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t5 || $[14] !== t7) {
    t8 = <HeroSimple title={t5} withoutCharacters={true} circleClassName="top-[150%] rotate-0">{t7}</HeroSimple>;
    $[13] = t5;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== data || $[17] !== isPending) {
    t9 = !isPending && typeof window !== "undefined" ? data?.getConsents() || {} : {};
    $[16] = data;
    $[17] = isPending;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== data || $[20] !== t) {
    t10 = async values => {
      if (data) {
        await sleep(200);
        toast.success(t("actions.success"));
        data.updateConsents(values);
      }
    };
    $[19] = data;
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== cookies || $[23] !== data?.CONSENT_ANALYTICS || $[24] !== data?.CONSENT_PERSONALIZATION || $[25] !== data?.CONSENT_REMARKETING || $[26] !== isPending || $[27] !== t) {
    t11 = t12 => {
      const {
        handleSubmit,
        submitting
      } = t12;
      return <form onSubmit={handleSubmit} {...addPrefixToDataParams({
        analyticsParam: "privacySettings",
        testId: "privacySettings",
        prefix: "form"
      })}><div className="mx-auto flex max-w-192 flex-col gap-2 lg:gap-4"><SettingBox title={t("essentials.title")} text={t("essentials.text")} icon={<IconGlobe />} cookies={cookies?.filter(_temp)} control={<SwitchInput label={t("essentials.title")} input={{
            checked: true,
            disabled: true
          }} meta="" />} /><SettingBox title={t("personalization.title")} text={t("personalization.text")} icon={<IconPuzzle />} cookies={cookies?.filter(_temp2)} control={!isPending && <Field type="checkbox" name={data?.CONSENT_PERSONALIZATION || cookiesCategory.personalization}>{_temp3}</Field>} /><SettingBox title={t("remarketing.title")} text={t("remarketing.text")} icon={<IconPackages />} cookies={cookies?.filter(_temp4)} additionalCookies={{
            description: t("remarketing.additionalCookies.description"),
            list: [{
              title: "ad_user_data",
              description: t("remarketing.additionalCookies.list.1.description"),
              category: "remarketing",
              link: "https://support.google.com/google-ads/answer/13802165?hl=cs"
            }, {
              title: "ad_personalization",
              description: t("remarketing.additionalCookies.list.2.description"),
              category: "remarketing",
              link: "https://support.google.com/google-ads/answer/13802165?hl=cs"
            }]
          }} control={!isPending && <Field type="checkbox" name={data?.CONSENT_REMARKETING || cookiesCategory.remarketing}>{_temp5}</Field>} /><SettingBox title={t("analytics.title")} text={t("analytics.text")} icon={<IconUserGroup />} cookies={cookies?.filter(_temp6)} control={!isPending && <Field type="checkbox" name={data?.CONSENT_ANALYTICS || cookiesCategory.analytics}>{_temp7}</Field>} /></div><Button analyticsParam="questionnaireFormSubmit" testId="questionnaireFormSubmit" variant="primary" type="submit" size="lg" align="center" className="mt-12 lg:mt-20" busy={isPending || submitting}>{t("actions.submit")}</Button></form>;
    };
    $[22] = cookies;
    $[23] = data?.CONSENT_ANALYTICS;
    $[24] = data?.CONSENT_PERSONALIZATION;
    $[25] = data?.CONSENT_REMARKETING;
    $[26] = isPending;
    $[27] = t;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== t10 || $[30] !== t11 || $[31] !== t9) {
    t12 = <div className="relative z-10 pb-20 text-left lg:pb-40"><div className="px-4"><FinalForm initialValues={t9} onSubmit={t10}>{t11}</FinalForm></div></div>;
    $[29] = t10;
    $[30] = t11;
    $[31] = t9;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== t12 || $[34] !== t8) {
    t13 = <div className="bg-blue-50">{t8}{t12}</div>;
    $[33] = t12;
    $[34] = t8;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  let t14;
  if ($[36] !== menuPromoBanners || $[37] !== t13 || $[38] !== t4) {
    t14 = <Layout menuPromoBanners={menuPromoBanners}>{t4}{t13}</Layout>;
    $[36] = menuPromoBanners;
    $[37] = t13;
    $[38] = t4;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  return t14;
}
function _temp7(fieldRenderProps_1) {
  return <SwitchInput {...fieldRenderProps_1} />;
}
function _temp6(t0) {
  const {
    category: category_2
  } = t0;
  return category_2 === cookiesCategory.analytics;
}
function _temp5(fieldRenderProps_0) {
  return <SwitchInput {...fieldRenderProps_0} />;
}
function _temp4(t0) {
  const {
    category: category_1
  } = t0;
  return category_1 === cookiesCategory.remarketing;
}
function _temp3(fieldRenderProps) {
  return <SwitchInput {...fieldRenderProps} />;
}
function _temp2(t0) {
  const {
    category: category_0
  } = t0;
  return category_0 === cookiesCategory.personalization;
}
function _temp(t0) {
  const {
    category
  } = t0;
  return category === cookiesCategory.essentials;
}
export const getStaticProps = (async ctx => {
  return {
    props: {
      cookies: await getAllCookies(),
      menuPromoBanners: await getAllPageMenuPromoBanners(),
      ...(await getIntlProps(ctx, ['core', 'privacySettings']))
    }
  };
}) satisfies GetStaticProps<Props>;